import Icon from "./Icon";
import Reveal from "./Reveal";
import { BENEFITS } from "../data/content";

// Horizontal row of benefit icons used across multiple pages.
export const BenefitsRow = ({ items = BENEFITS, compact = false }) => (
  <div
    className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-4"
    data-testid="benefits-row"
  >
    {items.map((b, i) => (
      <Reveal key={b.title} delay={i * 0.05}>
        <div className="group flex flex-col items-center text-center gap-3 rounded-2xl bg-white/60 border border-slate-100 py-6 px-3 hover:bg-white hover:shadow-[0_8px_30px_rgb(15,23,42,0.06)] transition-all duration-300">
          <span className="flex items-center justify-center w-12 h-12 rounded-full bg-sky-50 text-royal group-hover:bg-royal group-hover:text-white transition-colors duration-300">
            <Icon name={b.icon} className="w-6 h-6" />
          </span>
          <span className="font-heading text-sm font-semibold text-navy-900">{b.title}</span>
          {!compact && <span className="text-xs text-slate-400 leading-snug">{b.desc}</span>}
        </div>
      </Reveal>
    ))}
  </div>
);

export default BenefitsRow;
